declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

export function track(eventName: string, params?: Record<string, any>) {
  if (!window.fbq) return;
  window.fbq('track', eventName, params);
}
